import React from "react";
import styleAddNewElectronicPayment from "./AddNewElectronicPayment.module.css";
import MainContent from '../../layouts/maincontent/MainContent';
import { useContext, useEffect, useState } from "react";
import { jsPDF } from "jspdf";
import * as htmlToImage from 'html-to-image';
import logo from "../../assets/img/pdf-logo.png";
import asset from "../../assets/img/asset.png";

import { useNavigate } from "react-router-dom";
import SaveTaxDeclaration from "../../components/taxDeclaration/saveTaxDeclaration/SaveTaxDeclaration";
import { getUser } from "../../adapters/apis/auth/auth";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import ElectronicPaymentConfirm from "../../components/electronicPayment/ElectronicPaymentConfirm";
import styleAddNewTaxDeclaration from "../taxDeclaration/addNewTaxDeclaration/AddNewTaxDeclaration.module.css";
function AddElectronicPaymentConfirm() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {

  }, []);
  const saveAsPDF = async () => {



  };

  return (
      <MainContent>
        { isLoading ? <LoadingSpinner /> :
            <section className={ `${styleAddNewTaxDeclaration["section-content"]} section-content` }>
              <div className={ `${styleAddNewTaxDeclaration.container} container pt-5` }>
                <div className={ `${styleAddNewTaxDeclaration["card-box"]} card-box` }>
                  <div className={ `${styleAddNewTaxDeclaration["header-all-btns"]} header-all-btns` }>

                  </div>
                  <div className={ `${styleAddNewTaxDeclaration.title} title` }>
                  <h3>بيانات الدفع الإلكترونى </h3>
                  </div>
                  <div className={ `${styleAddNewTaxDeclaration["box-content"]} box-content` }>
                    <ElectronicPaymentConfirm/>
                  </div>
                </div>
              </div>
            </section> }
      </MainContent>
  );

};

export default AddElectronicPaymentConfirm;